<template>
  <el-dialog
    :visible.sync="Visible"
    title="设置公式"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-row>
      <el-col :span="24">
        <el-button class="pull-right right-10" icon="el-icon-plus" size="mini" @click="addRow">新增公式行</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      size="mini"
      border
      :highlight-current-row="true"
      class="toggletable"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" fixed></el-table-column>
      <el-table-column label="删除" width="50" fixed>
        <template slot-scope="scope">
          <el-tooltip content="删除" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteRow(scope.$index, scope.row.id)"
              size="mini"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="" min-width="90" fixed>
        <template slot-scope="scope">
          
          <el-select v-model="scope.row.calc1" size="mini" clearable>
            <el-option v-for="item in calcData" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <span>{{scope.row.calc1}}</span>
        </template>
      </el-table-column>

      <el-table-column label="字段" min-width="90" fixed>
        <template slot-scope="scope">
          
          <el-select v-model="scope.row.fieldName" placeholder="请选择字段" size="mini" clearable>
            <el-option v-for="item in detailParamItems" :key="item.fieldName" :label="item.fieldName" :value="item.fieldName"></el-option>
          </el-select>
          <span>{{scope.row.fieldName}}</span>
        </template>
      </el-table-column>

      <el-table-column label="编码/名称" min-width="90" fixed>
        <template slot-scope="scope">
            <el-select v-model="scope.row.type" placeholder="请选择编码/名称" size="mini" clearable >
              <el-option value="编码">编码</el-option>
              <el-option value="名称">名称</el-option>
            </el-select>
            <span>{{scope.row.type}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="90" fixed>
        <template slot-scope="scope">
          <el-select v-model="scope.row.oper" placeholder="请选择操作" size="mini" clearable>
                <el-option v-for="item in formulaOperData" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span>{{scope.row.oper}}</span>
        </template>
      </el-table-column>

      <el-table-column label="值" min-width="90" fixed>
        <template slot-scope="scope">
            <el-input v-model="scope.row.value" size="mini"></el-input>
            <span>{{scope.row.value}}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="" min-width="90" fixed>
        <template slot-scope="scope">
          
          <el-select v-model="scope.row.calc2"  size="mini" clearable>
            <el-option v-for="item in calcData" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <span>{{scope.row.calc2}}</span>
        </template>
      </el-table-column>

      <el-table-column label="" min-width="90" fixed>
        <template slot-scope="scope">
          
          <el-select v-model="scope.row.calc3"  size="mini" clearable>
            <el-option v-for="item in calcData" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <span>{{scope.row.calc3}}</span>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="info" size="medium" @click="closeSelect" icon="el-icon-close">取 消</el-button>
    </span>
  </el-dialog>
</template>
  
<script>
import pagerBar from "@/views/pager/pagerBar";
import config from "../../common/config";
export default {
  components: {
    pagerBar
  },
  data() {
    return {
      Visible: false,
      loading: true,
      type: "",
      tableData: [],

      accountConfInfoValue: "",
      brandValue: "",
      storeValue: "",
      subjectTypeId: 0,
      detailParamItems: [],
      moduleMark: "",
      formulaOperData: ["包含", "等于", "前缀等于", "后缀等于"],
      calcData: ["(",")","并且","或者"]
    };
  },
  methods: {
    search() {
    },
    open(accountConfInfoValue,brandValue, storeValue, subjectTypeId,detailParamItems,moduleMark) {
      this.accountConfInfoValue = accountConfInfoValue;
      this.brandValue = brandValue;
      this.storeValue = storeValue;
      this.subjectTypeId = subjectTypeId;
      this.detailParamItems = detailParamItems;
      this.moduleMark = moduleMark;
      
      this.tableData = [];
      this.Visible = true;
      this.loading = false;
      //   this.type = type;
      //   this.getDataUrl =
      //     config.BASE_Middle_API +
      //     "SubjectDetails/" +
      //     (type == "会计科目" ? "OppositeSubjects" : "SubjectFieldDataForSelect");

    },
    initData(d) {
      this.tableData = d;
      this.loading = false;
    },
    addRow(){
      this.tableData.push({});
    },
    closeSelect() {
      this.Visible = false;
    },
    closeOpenloading() {
      this.loading = false;
    }
  }
};
</script>
  <style scoped="scoped">
.w50 {
  width: 48.5%;
  display: inline-block;
}
.text-flow {
  float: left;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.w25 {
  width: 25%;
}
.w45 {
  width: 45%;
}
.w30 {
  width: 30%;
}
.w35 {
  width: 35%;
}
.w65 {
  width: 65%;
}
.w70 {
  width: 70%;
}
.w33 {
  width: 33%;
}
.wl-select-group__wrap li span {
  color: #909399;
}
.wl-select-group__wrap + .el-select-dropdown__item {
  margin-top: 28px;
}
.oppoul {
  white-space: nowrap;
}
.oppoli {
  list-style: none;
  display: inline-block;
}

.oppoul li {
  text-align: left;
  padding-left: 0px;
  width: 25%;
}
.oppoul li:nth-child(2) {
  width: 45% !important;
}
.oppoul li:nth-child(3) {
  width: 30% !important;
}

.toggletable .el-select,
.toggletable .el-input,
.toggletable .myshowup {
  display: none;
  margin-right: 5px;
}

.toggletable .current-row .myshowup + .el-select {
  display: inline-block;
}
.toggletable .current-row .el-select {
  display: block;
}
.toggletable .current-row .el-input {
  display: block;
}
.toggletable .current-row .myshowup.el-button {
  display: inline-block;
}
.toggletable .current-row .el-select + span {
  display: none;
}
.toggletable .current-row .el-input + span {
  display: none;
}
.myshowup.el-button {
  border-radius: 16px;
}
.toggleColumn .myshowup {
  display: none !important;
}
.current-row .toggleColumn .el-select {
  display: block !important;
  width: 100%;
}
.current-row .toggleColumn .el-input {
  display: block !important;
  width: 100%;
}
.current-row .toggleColumn span {
  display: none;
}
.toggleColumn .el-select {
  display: none !important;
  width: 100%;
}
.toggleColumn .el-input {
  display: none !important;
  width: 100%;
}
.toggleColumn span {
  display: block;
}
.floatleft {
  float: left;
}
</style>